import React, { useEffect } from "react";

import { useDocTitle } from "../../utils/hooks";
import { Pension } from "../Calculators/Pension";
import { Aportes } from "../Calculators/Aportes";
import { useState } from "react";
import { useForm } from "../../utils/hooks";
import GlobalLoading from "../../components/common/GlobalLoading";

const OPTIONS = Object.freeze({
  APORTES: "APORTES",
  PENSION: "PENSION",
});

const PublicCalculators = () => {
  useDocTitle("Calculadoras");

  const [currentSelection, setCurrentSelection] = useState<string>(
    OPTIONS.APORTES
  );
  const [data, setData] = useState<any>({});
  const [dataDetalle, setDataDetalle] = useState<any[]>([]);
  const [chartData, setChartData] = useState<any>({
    labels: [],
    datasets: [],
  });
  const [formState, setError, changeHandler, reset] = useForm({
    salario: "0",
  });

  // Pensión
  const [dataPension, setDataPension] = useState([]);
  const [
    formStatePension,
    setErrorPension,
    changeHandlerPension,
    resetPension,
  ] = useForm({
    Genero: "",
    Edad: "",
    EdadRetiro: "",
    MontoCCI: "",
    Salario: "",
    AporteExtra: "",
    AporteVoluntario: "",
  });

  useEffect(() => {
    var launcher = document.getElementById("launcher");
    launcher?.remove();

    var botprofrm = document.getElementById("botprofrm");
    botprofrm?.remove();
  }, []);
  
  return (
    <>
      <GlobalLoading />
      <div className="block pt-12 pb-32 md:pb-12">
        <nav className="control-calculator">
          <button
            onClick={() => setCurrentSelection(OPTIONS.APORTES)}
            className={`item-tab ${
              currentSelection === OPTIONS.APORTES ? "active" : ""
            }`}
          >
            <div className="icon-container">
              <i className="icon icon-cashv2"></i>
            </div>
            <h5>Calculadora de Aportes</h5>
          </button>
          <button
            onClick={() => setCurrentSelection(OPTIONS.PENSION)}
            className={`item-tab ${
              currentSelection === OPTIONS.PENSION ? "active" : ""
            }`}
          >
            <div className="icon-container">
              <i className="icon icon-analytics"></i>
            </div>
            <h5>Calculadora de Pensión</h5>
          </button>
        </nav>

        {currentSelection === OPTIONS.APORTES && (
          <Aportes
            data={data}
            setData={setData}
            dataDetalle={dataDetalle}
            setDataDetalle={setDataDetalle}
            chartData={chartData}
            setChartData={setChartData}
            formState={formState}
            changeHandler={changeHandler}
          />
        )}
        {currentSelection === OPTIONS.PENSION && (
          <Pension
            data={dataPension}
            setData={setDataPension}
            formState={formStatePension}
            changeHandler={changeHandlerPension}
          />
        )}
      </div>
    </>
  );
};

export default PublicCalculators;
